import deDEDictionary from './assets/dictionaries/de-DE.json'
import enUSDictionary from './assets/dictionaries/en-UK.json'
import esESDictionary from './assets/dictionaries/es-ES.json'
import frFRDictionary from './assets/dictionaries/fr-FR.json'
import itITDictionary from './assets/dictionaries/it-IT.json'
import jaJPDictionary from './assets/dictionaries/ja-JP.json'
import ptPTDictionary from './assets/dictionaries/pt-PT.json'
import ptBRDictionary from './assets/dictionaries/pt-BR.json'
import trTRDictionary from './assets/dictionaries/tr-TR.json'
import zhCNDictionary from './assets/dictionaries/zh-CN.json'
import zhHKDictionary from './assets/dictionaries/zh-HK.json'
import thTHDictionary from './assets/dictionaries/th-TH.json'

import deDECalendar from './assets/calendars/de-DE.json'
import enUSCalendar from './assets/calendars/en-US.json'
import esESCalendar from './assets/calendars/es-ES.json'
import frFRCalendar from './assets/calendars/fr-FR.json'
import itITCalendar from './assets/calendars/it-IT.json'
import jaJPCalendar from './assets/calendars/ja-JP.json'
import ptBRCalendar from './assets/calendars/pt-BR.json'
import ptPTCalendar from './assets/calendars/pt-PT.json'
import trTRCalendar from './assets/calendars/tr-TR.json'
import zhCNCalendar from './assets/calendars/zh-CN.json'
import zhHKCalendar from './assets/calendars/zh-HK.json'

export class I18nHelper {
    static dictionaries = (): any => {
        return {
            'de-DE': deDEDictionary,
            'en-US': enUSDictionary,
            'es-ES': esESDictionary,
            'fr-FR': frFRDictionary,
            'it-IT': itITDictionary,
            'ja-JP': jaJPDictionary,
            'pt-BR': ptBRDictionary,
            'pt-PT': ptPTDictionary,
            'tr-TR': trTRDictionary,
            'zh-CN': zhCNDictionary,
            'zh-HK': zhHKDictionary,
            'th-TH': thTHDictionary,
        }
    }

    static calendars = (): any => {
        return {
            'de-DE': deDECalendar,
            'en-US': enUSCalendar,
            'es-ES': esESCalendar,
            'fr-FR': frFRCalendar,
            'it-IT': itITCalendar,
            'ja-JP': jaJPCalendar,
            'pt-BR': ptBRCalendar,
            'pt-PT': ptPTCalendar,
            'tr-TR': trTRCalendar,
            'zh-CN': zhCNCalendar,
            'zh-HK': zhHKCalendar,
        }
    }

    static supportedLanguages = (): any => {
        return [
            { label: 'de-DE', value: 'de-DE' },
            { label: 'en-US', value: 'en-US' },
            { label: 'es-ES', value: 'es-ES' },
            { label: 'fr-FR', value: 'fr-FR' },
            { label: 'it-IT', value: 'it-IT' },
            { label: 'ja-JP', value: 'ja-JP' },
            { label: 'pt-BR', value: 'pt-BR' },
            { label: 'pt-PT', value: 'pt-PT' },
            { label: 'tr-TR', value: 'tr-TR' },
            { label: 'zh-CN', value: 'zh-CN' },
            { label: 'zh-HK', value: 'zh-HK' },
            { label: 'th-TH', value: 'th-TH' },
        ]
    }
}

export const i18nSupportedLanguages = I18nHelper.supportedLanguages()
export const i18nDictionaries: any = I18nHelper.dictionaries()
export const i18nCalendars: any = I18nHelper.calendars()
